<template>
  <div class="atPage">
    <div class="signList" :class="status && 'show'">
      <div class="snTitle flex-center">朗读指导列表</div>
      <ul>
        <li class="flex-center" :class="!curId && 'on'" @click="selectItem({})" v-if="isAll">
          <div class="snTxt flex-center all">全部</div>
        </li>
        <li class="flex-center" :class="curId === item.id && 'on'" v-for="(item, idx) in knowledgeList" :key="item.id"
          @click="selectItem(item, idx)">
          <span class="flex-center">{{ idx + 1 }}</span>
          <div class=" snTxt ">
            <p class="line1">{{ item.text }}</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="smClass" v-show="getCurKnowledge.classStatus">
      <div class="smBoard">
        <div class="smMain">
          <div class="smt ql-editor" v-html="curKnowledge.content"></div>
        </div>
        <span class="smBtn iconfont flex-center" :class="isPlaying ? 'xingzhuangjiehe2' : 'lujing1'"
          v-if="curKnowledge.voiceUrl" @click="changeStatus(curKnowledge.voiceUrl)"></span>
        <img class="smBook" src="~images/smBook.png" v-else />
      </div>
      <img class="smClose" src="~images/smClose.png" @click="closeClass" />
    </div> -->
    <Drawer size="22%" :with-header="false" :visible.sync="getCurKnowledge.classStatus"  :before-close="closeClass">
      <div class="smBoard">
        <div class="smMain">
          <div class="smt ql-editor" v-html="curKnowledge.content"></div>
        </div>
        <div class="smBtn iconfont flex-center" :class="isPlaying ? 'xingzhuangjiehe2' : 'lujing1'"
          v-if="curKnowledge.voiceUrl" @click="changeStatus(curKnowledge.voiceUrl)"></div>
      </div>
    </Drawer>
    <video id="classVideo" width="320" height="240" controls v-show="getCurKnowledge.videoStatus"
      controlsList="nodownload noplaybackrate " disablePictureInPicture :src="curKnowledge.videoUrl">
      您的浏览器不支持 HTML5 video 标签。
    </video>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import audioMixin from 'mixin/audio';
import { Drawer } from "element-ui";
export default {
  props: {
    courseId: {
      type: String,
    },
    status: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [audioMixin],
  components: { Drawer },
  data() {
    return {
      curId: null,
      showClass: true,
    };
  },
  created() {
    this.changeCourse()
  },
  mounted() {
    // 监听全屏变化事件
    const video = document.getElementById("classVideo");
    video.addEventListener('fullscreenchange', () => {
      // 检查是否退出全屏
      const isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen;
      if (!isFullScreen) {
        video.pause()
        // 退出全屏操作
        this.$store.commit("setCurKnowledge", {
          ...this.getCurKnowledge,
          videoStatus: false,
        });
      } else {
        this.$emit('onPlay')
      }
    });
  },
  computed: {
    ...mapGetters(["getKnowledgeSigns", "getKnowledgeStatus", "getCurKnowledge"]),
    curKnowledge() {
      return this.getKnowledgeSigns[this.getCurKnowledge.signId - 1] || {};
    },
    isAll() {
      const idx = this.getKnowledgeSigns.findIndex(item => item.isOverall);
      return idx > -1;
    },
    knowledgeList() {
      const idx = this.getKnowledgeSigns.findIndex(item => item.isOverall);
      // const list = Object.assign([],this.getKnowledgeSigns)
      return idx > -1 ? this.getKnowledgeSigns.slice(1) : this.getKnowledgeSigns;
    }
  },
  methods: {
    selectItem(item, idx) {
      this.curId = item.id || null;
      // 数据返回有全部需要剔除，id排序需加1
      const alt = this.knowledgeList.length != this.getKnowledgeSigns.length ? 2 : 1;
      this.$store.commit("setCurKnowledge", {
        domId: item.id ? 'sign_' + (idx + alt) : 'book-words'
      });

      this.$emit('change')
    },
    closeClass() {
      this.$store.commit("setCurKnowledge", {
        ...this.getCurKnowledge,
        classStatus: false
      });
      this.globalAudio.pause();
    },
    changeCourse() {
      this.showClass = false;
      typeof this.globalAudio.pause == 'function' && this.globalAudio.pause();
      this.$store.commit('setCurKnowledge', {});
      this.$store.dispatch('queryKnowledgeSigns', this.courseId);
    }
  },
  watch: {
    getCurKnowledge(val, oldVal) {
      const video = document.getElementById("classVideo");
      if (video && val.videoStatus) {
        this.$store.commit("setGlobalAudio", false);
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) { // Firefox
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) { // Chrome, Safari and Opera
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { // IE/Edge
          video.msRequestFullscreen();
        }
      }
    },
    courseId(val) {
      if (val) this.changeCourse()
    }
  },
  beforeDestroy() {
    document.getElementById("classVideo")?.removeEventListener('fullscreenchange', null)
  },
};
</script>

<style lang="less" scoped>
.signList {
  width: 220px;
  // height: 324px;
  background: #FFFFFF;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 80px;
  right: 0;
  z-index: -9;
  transition: all .28s ease;
  opacity: 0;

  &.show {
    opacity: 1;
    z-index: 4;
  }

  .snTitle {
    border-bottom: 1px solid #ECECEC;
    font-size: 12px;
    color: #666666;
    height: 44px;
  }

  ul {
    padding: 0 10px 12px;
    max-height: 420px;
    overflow: auto;
    box-sizing: border-box;
    cursor: pointer;

    li {
      position: relative;
      padding-top: 8px;

      &::before {
        content: '';
        position: absolute;
        left: 11px;
        width: 2px;
        height: 100%;
        background: #F6F6F6;
        z-index: -1;
      }

      span {
        width: 24px;
        height: 24px;
        background: #F6F6F6;
        border-radius: 50%;
        margin-right: 10px;
        color: #999999;
      }

      .line2 {
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /* 这里是超出几行省略 */
        overflow: hidden;
        box-sizing: border-box;
      }

      .snTxt {
        color: #666666;
        flex: 1;
        background: #F6F6F6;
        font-size: 16px;
        height: 60px;
        // line-height: 60px;
        padding: 8px 10px;
        overflow: hidden;
        line-height: 22px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        &.all {
          height: 40px;
        }
      }

      &.on,
      &:hover {

        span,
        .snTxt {
          background: #E5FFE5;
          color: #57AE59;
        }
      }

      &.on {
        font-weight: bold;
      }
    }
  }
}

// .smClass {
//   position: fixed;
//   right: 24px;
//   top: 80px;
//   z-index: 6;
//   cursor: pointer;
//   display: flex;
//   flex-direction: column;

.smBoard {
  // overflow: hidden;
  // position: relative;
  // width: 308px;
  // height: 299px;
  // background: url('~images/smBoard.png') no-repeat center;
  // background-size: contain;
  // padding-top: 44px;
  // box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 26px;

  .smBtn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #57AE59;
    color: #fff;
    margin-top: 20px;
    cursor: pointer;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    // bottom: 8px;
    font-size: 16px;

    &.lujing1 {
      padding-left: 2px;
    }
  }

  // .smBook {
  //   position: absolute;
  //   left: 50%;
  //   transform: translateX(-50%);
  //   bottom: 10px;
  //   width: 48px;
  //   height: 21px;
  // }


  .smMain {
    flex: 1;
    overflow: hidden;
    // font-size: 12px;
    // color: #FFFFFF;
    // line-height: 17px;
    // padding: 0 24px;

    .smc {
      font-size: 12px;
      transform: scale(.85);
      color: #A6F4A8;
      line-height: 14px;
      margin-bottom: 10px;
      text-align: center;
    }
  }
}

.smClose {
  width: 28px;
  height: 32px;
  margin-top: -2px;
  margin-left: 60px;
}

// }

#classVideo {
  position: fixed;
  right: 0;
  top: 0;
}

/deep/ .smBoard {
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    font-size: revert;
    font-weight: revert;
    margin: revert;
  }

  img {
    width: 100%;
  }
}
</style>
